<template>
  <transition name="emat-popup-animation">
    <div class="emat-popup" v-if="menu">
      <div class="emat-popup-card-holder">
        <div class="emat-popup-card" :class="classes">
          <div class="emat-popup-card-header">
            <slot name="header"></slot>
            <lord-icon
              v-if="showClose"
              @click="close"
              class="emat-close current-color"
              src="https://cdn.lordicon.com/dfyonbvl.json"
              trigger="hover"
              :colors="lordIconColors('--c-btn-close-background')"
              style="width:36px; height:36px">
            </lord-icon>
          </div>
          <div class="emat-popup-card-body">
            <slot name="body"></slot>
          </div>
          <div class="emat-popup-card-footer" v-if="!!$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
      <div class="emat-popup-overlay" @click="close"></div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import lordIcons from '../../../mixins/lordIcons';

export default {
  name: 'EmatPopup',

  mixins: [lordIcons],

  props: {
    /**
     * A label for the product
     */
    label: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Boolean to open or close menu
     */
    menu: {
      type: Boolean,
      required: true,
    },

    /**
     *  Shows or hide the close icon
     */
    showClose: {
      type: Boolean,
      default: true,
    },

    /**
     * Can set a extra state for the modal. You can choose between ['success', 'warning', 'error']
     */
    state: {
      type: String,
      default: null,
      validator: function (value) {
        return ['success', 'warning', 'error'].indexOf(value) !== -1;
      },
    },
  },

  methods: {
    onChange(val) {
      /**
       * Output the input for v-model
       */
      this.$emit('input', val);

      /**
       * Output the change with the new value
       */
      this.$emit('change', val);
    },

    close() {
      this.$emit('click', false);
      this.$emit('close');
    },
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
    }),

    classes() {
      let classes = {};

      // sets the key on true
      // for example: {success: true} to append success class
      if (this.state)
        classes[this.state] = true;

      return classes;
    },
  },

  watch: {
    menu: {
      handler(val) {
        this.onChange(val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/sass/abstracts";

$card-background-color-heading: #F4F4F4;
$p-card: 20px;

$c-grey-light: #AEAEAE;

// popup
.emat-popup-animation {
  &-enter-active,
  &-leave-active {
    transition: all .3s ease;

    .emat-popup-card, .emat-popup-overlay {
      transition: all .3s ease;
    }
  }

  &-enter,
  &-leave-to {
    .emat-popup-card {
      transform-origin: top center;
      transform: translateY(-40px) scale(0.8);
      opacity: 0;
    }

    .emat-popup-overlay {
      opacity: 0;
    }
  }
}

/* .popup-animation */

.emat {
  &-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    font-family: var(--font);

    &-overlay {
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
    }

    &-card-holder {
      width: 590px;
      max-width: 100%;
      height: auto;
      position: relative;
      z-index: 2;
      margin: 15px;
      border-radius: $border-radius;

      @media only screen and (max-width: 576px) {
        max-height: 90%;
        overflow: auto;
      }
    }

    &-card {
      background: white;
      border-radius: $border-radius;

      &.warning > &-header {
        color: var(--c-warning);
      }

      &.success > &-header {
        color: var(--c-success);
      }

      &.error > &-header {
        color: var(--c-danger);
      }

      &-header {
        @include header-font;
        position: relative;
        display: flex;
        padding: $p-card;
        align-items: center;
        font-size: 20px;
        padding-right: 50px;
        box-shadow: $box-shadow;
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;
        background: var(--c-panel-heading-bg);
        color: var(--c-title-in-panel);

        p {
          margin: 0;

          img {
            border: none !important;
          }
        }

        .emat-close {
          position: absolute;
          right: 10px;
          cursor: pointer;
          color: var(--c-title-in-panel);
        }
      }

      &-body {
        max-height: calc(75vh - 100px);
        overflow-y: auto;

        @media only screen and (max-width: 576px) {
          overflow: auto;
        }
      }

      &-footer {
        position: relative;
      }
    }
  }
}
</style>
